import { useNavigation as useReactNavigation } from '@react-navigation/native'

function useNavigation() {
  const navigation = useReactNavigation()
  const navigateWithTimeTracking = (screen: string, payload?: object) => {
    navigation.navigate(screen as never, (payload as never) || ({} as never))
  }
  const replaceWithTimeTracking = (screen: string, payload?: object) => {
    navigation.replace(screen as never, (payload as never) || ({} as never))
  }
  return {
    ...navigation,
    navigate: navigateWithTimeTracking,
    replace: replaceWithTimeTracking,
  }
}

export { useNavigation }
